import React, { useEffect, useRef, useState } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Container,
  Divider,
  Grid,
  Paper,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { PostPosition } from '../services/httpServices';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

const AddPosition = (props) => {
  const navigate = useNavigate();

  const [vertical, setVertical] = useState('bottom');
  const [horizontal, setHorizontal] = useState('right');
  const [open, setOpen] = useState(false);
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');

  const positionNameRef = useRef('');
  const positionCodeRef = useRef('');

  const fetch = async (event) => {
    setLoading(false);
  };
  useEffect(() => {
    fetch();
  }, []);

  const SaveUser = async (event) => {
    // setPosting(true);
    event.preventDefault();
    //console.log('saveHit');
    const payload = {
      code: positionNameRef.current.value,
      name: positionNameRef.current.value,
    };

   // console.log(payload);
    let response = await PostPosition(payload);
  //  console.log('PostResponse:', response);

    if (response.status == 200) {
      setMessage(response.data);
      setSaved(true);
      setOpen(true);
      setTimeout(() => {
        navigate(-1);
      }, 2000);
    } else {
      setMessage(response.data);
      setSaved(false);
      setOpen(true);
      setTimeout(() => {
        navigate(-1);
      }, 2000);
      // setPosting(false);
    }
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Helmet>
        <title> Add Position | Immigration System </title>
      </Helmet>
      <Container>
        <form onSubmit={SaveUser}>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <Typography variant="h4" gutterBottom>
              Create Position
            </Typography>
            {/* <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />}> */}

            <Stack direction="row" divider={<Divider orientation="vertical" flexItem />} spacing={2}>
              <Button
                onClick={() => {
                  navigate(-1);
                }}
                variant="contained"
              >
                Back
              </Button>
              <Button type="submit" variant="contained">
                Create
              </Button>
            </Stack>
          </Stack>
          {loading ? (
            <Grid display="flex" alignItems="center" justifyContent="center" height="40vh" container>
              <CircularProgress size={60} thickness={3} value={100} />
            </Grid>
          ) : (
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Box component={Paper} p={4}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={4} md={6}>
                      <TextField
                        label="Position Code"
                        required
                        variant="outlined"
                        fullWidth
                        size="small"
                        inputRef={positionCodeRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={6}>
                      <TextField
                        label="Position Name"
                        required
                        variant="outlined"
                        fullWidth
                        size="small"
                        inputRef={positionNameRef}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          )}
        </form>
        {saved ? (
          <Snackbar
            anchorOrigin={{ vertical, horizontal }}
            key={vertical + horizontal}
            open={open}
            autoHideDuration={4000}
            onClose={handleClose}
          >
            <Alert elevation={6} variant="filled" onClose={handleClose} severity="success">
              {message}
            </Alert>
          </Snackbar>
        ) : (
          <Snackbar
            key={vertical + horizontal}
            anchorOrigin={{ vertical, horizontal }}
            open={open}
            autoHideDuration={4000}
            onClose={handleClose}
          >
            <Alert elevation={6} variant="filled" onClose={handleClose} severity="error">
              {message}
            </Alert>
          </Snackbar>
        )}
      </Container>
    </>
  );
};

export default AddPosition;
